module.exports = __webpack_public_path__ + "media/images/bg/mosaic/concert-5004e4f2b1e9b8d9134ff691ade76c3c.jpg";